import React, { useContext } from 'react'
import styled from 'styled-components'
import { ASPECT_RATIO } from '../../index'
import Preview from '../../upload-preview'
import { ZoomMakerDownloadContext } from '../context'

const PREVIEW_WIDTH = 598

const Canvas = styled(Preview)`
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
    height: ${PREVIEW_WIDTH / ASPECT_RATIO}px;
    margin: 0 auto 40px;
    overflow: hidden;
    position: relative;
    width: ${PREVIEW_WIDTH}px;
`

const ZoomMakerDownloadPreview = () => {
    const { frames, status } = useContext(ZoomMakerDownloadContext)
    return <Canvas frames={frames} status={status} />
}

export default ZoomMakerDownloadPreview
